import React from "react";
import Slider from "react-slick";
import { Star, User } from "react-feather";

const HMSTestimonials = () => {

    const settings = {
        dots: false,
        infinite: true,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 992,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 576,
                settings: { slidesToShow: 1 }
            }
        ]
    };

    const testimonials = [
        {
            name: "Dr. Rajesh Sharma",
            hospital: "Apollo Care, Delhi",
            review: "HMS AZSM has completely transformed our hospital operations. From patient records to billing, everything is seamless.",
            rating: 5
        },
        {
            name: "Dr. Priya Mehta",
            hospital: "Sunrise Hospital, Mumbai",
            review: "The real-time reports and appointment management features have improved our efficiency significantly.",
            rating: 5
        },
        {
            name: "Amit Verma",
            hospital: "City Care Clinic, Indore",
            review: "Inventory and pharmacy modules are extremely helpful. Easy to use and highly reliable software.",
            rating: 4
        },
        {
            name: "Dr. Neha Gupta",
            hospital: "HealthFirst Hospital, Bangalore",
            review: "Digital records and automation have reduced manual errors. Highly recommended HMS solution.",
            rating: 5
        },
        {
            name: "Rahul Singh",
            hospital: "Medico Hub, Jaipur",
            review: "Billing and analytics dashboard are powerful. Helps in making better decisions.",
            rating: 4
        }
    ];

    return (
        <section className="py-5 bg-white">
            <div className="container ">

                <div className="text-center mb-5">
                    <h2 className="fw-bold">HMS <span className="lanp-secondary-text">AZSM</span> Software Reviews</h2>
                    <p className="text-muted">
                        Trusted by hospitals and clinics across India for smart healthcare management
                    </p>
                </div>

                <Slider {...settings}>
                    {testimonials.map((item, index) => (
                        <div key={index} className="p-3">
                            <div className="card h-100 border-0 ">

                                <div className="card-body text-center">

                                    <div className="mb-3">
                                        <div className="bg-light rounded-circle d-inline-flex align-items-center justify-content-center"
                                            style={{ width: "70px", height: "70px" }}>
                                            <User className="lanp-secondary-text" size={32} />
                                        </div>
                                    </div>

                                    <h5 className="fw-bold mb-1">{item.name}</h5>
                                    <small className="text-muted d-block mb-3">{item.hospital}</small>

                                    <div className="mb-3">
                                        {[...Array(item.rating)].map((_, i) => (
                                            <Star key={i} size={16} fill="gold" stroke="gold" />
                                        ))}
                                    </div>

                                    <p className="text-muted small">
                                        "{item.review}"
                                    </p>

                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>

            </div>
        </section>

    );
};

export default HMSTestimonials;